import { z } from "zod";

export const webVitalMetricNames = ["CLS", "FCP", "INP", "LCP", "TTFB"] as const;
export const webVitalRatings = ["good", "needs-improvement", "poor"] as const;

export const webVitalSchema = z.object({
  effectiveConnectionType: z.string().max(30).optional(),
  id: z.string().min(1).max(128),
  name: z.enum(webVitalMetricNames),
  navigationType: z.string().max(30).optional(),
  path: z.string().startsWith("/").max(500),
  rating: z.enum(webVitalRatings),
  sessionId: z.string().uuid(),
  value: z.number().finite().nonnegative(),
});

export type WebVital = z.infer<typeof webVitalSchema>;
